export default __webpack_public_path__ + "static/media/ic_Facilitator.24a3a4ab.svg";